module.exports = __webpack_public_path__ + "img/small-truck.493b25b.png";